import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@psspl/utils';
const ROUNDED_CLASS = {
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
};
/**
 * Loading placeholder.
 *
 * Always supply a `label` so the loading state is announced, and always match the
 * final layout's dimensions so the swap to content does not shift the page.
 * See docs/ui-guidelines.md section 7.
 */
export function Skeleton({ width, height = '1rem', rounded = 'md', className, ...rest }) {
    return (_jsx("div", { "aria-hidden": "true", style: width === undefined && height === undefined ? undefined : { width, height }, className: cn('animate-pulse bg-surface-overlay', ROUNDED_CLASS[rounded], className), ...rest }));
}
/** Announces a loading region once, for screen readers, while skeletons stay decorative. */
export function SkeletonRegion({ label, className, children, }) {
    return (_jsxs("div", { role: "status", "aria-live": "polite", "aria-busy": "true", className: className, children: [_jsx("span", { className: "sr-only", children: label }), children] }));
}
//# sourceMappingURL=skeleton.js.map